import http from '../http'
import {RECOGNITION_URL, RECOGNITION_EDIT_URL, RECOGNITION_CREATE_URL, COUNTRIES_LIST} from '../../services/endpoints'

export function getRecognition(id) {
    return http.request({
        url:RECOGNITION_URL(id),
        method:'get'
    })
}
export function updateRecognition(id, recognition_id, postData) {
    return http.request({
        url:RECOGNITION_EDIT_URL(id, recognition_id),
        method:'put',
        data:postData
    })
}
export function createRecognition(postData){
  return http.request({
    url:RECOGNITION_CREATE_URL,
    method:'post',
    data:postData
  })
}
export function getCountriesList(data) {
  return http.request({
    url:COUNTRIES_LIST,
    method:'post',
    data:data
  })
}
export function getQualificationAreaList(){
  return http.request({
    url:'api/qualification/list',
    method:'get'
  })
}
export function copyRecognitionData(applicant_id){
  return http.request({
    url:'api/applicant/'+ applicant_id+'/recognition-copy',
    method:'post'
  })
}
export function getRecognitionDecisionDocumentList(applicant_id){
  return http.request({
    url:'api/applicant/'+ applicant_id+'/recognition-html-decision',
    method:'get'
  })
}
export function createRecognitionDecisionDocument(applicant_id){
  return http.request({
    url:'api/applicant/'+ applicant_id+'/recognition-html-decision',
    method:'post'
  })
}
export function updateRecognitionDecision(applicant_id, document_id, data) {
  return http.request({
    url:'api/applicant/'+ applicant_id+'/recognition-html-decision/'+document_id,
    method:'put',
    data
  })
}
export function downloadPdfRecognitionDecision(document_id) {
  return http.request({
    responseType: 'blob',
    url:'api/recognition-html-print/'+document_id,
    method:'post',
  })
}
